module.exports = require("./a");


/*****************
 ** WEBPACK FOOTER
 ** ./runtime/chunk-callback-order/b.js
 ** module id = 4
 ** module chunks = 3
 **/